<template>
  <div class="area">
    <div class="title">{{ title }}</div>
    <SiruiSearch :query="meterDetail" :columns="formColumn" :isQueryPanel="false"></SiruiSearch>
    <el-divider></el-divider>
  </div>
</template>
<script>
  import MeterAPI from '@/api/property/meterManagement';
  import { formColumn as baseFormColumns } from './informationCard.js';
  export default {
    name: 'InformationCard',
    props: {
      // 入参
      showMeterData: {
        type: Object,
        default: () => {},
      },
    },
    // 当前组件需要用的数据 data computed 局部变量 类 函数
    data() {
      return {
        meterDetail: {},
        title: '', //标题
        spaceNameList: [],
        smartFlagList: [
          {
            value: 0,
            label: '否',
          },
          {
            value: 1,
            label: '是',
          },
        ],
      };
    },
    computed: {
      formColumn() {
        return baseFormColumns(this);
      },
    },
    // mounted 简单可能就是几行代码
    mounted() {
      this.getDetail();
      this.settingTitle();
      this.getArea();
    },
    // 当组件的方法,可能比较多
    methods: {
      // 页面展示标题
      settingTitle() {
        const meterType = {
          1: '总表信息',
          2: '单元水表信息',
          3: '楼层水表信息',
        };
        this.title = meterType[this.showMeterData.type] || '房号水表信息';
      },
      // 电表详情
      async getDetail() {
        const { data } = await this.$axios.get(
          `${MeterAPI.WATER_METER_TREE}/${this.showMeterData.id}`
        );
        if (data.code == 0) {
          this.meterDetail = data.data.waterMeter || {};
          this.meterDetail.smartFlag = data.data.waterMeter.smartFlag.toString();
          if (this.meterDetail.inductanceRatio != null) {
            this.meterDetail.inductanceRatio = data.data.waterMeter.inductanceRatio.toString();
          }
          if (this.meterDetail.meterReadingWarning != null) {
            this.meterDetail.meterReadingWarning =
              data.data.waterMeter.meterReadingWarning.toString();
          }
          if (this.meterDetail.loss != null) {
            this.meterDetail.loss = data.data.waterMeter.loss.toString();
          }
        }
      },
      // 获取片区数据
      async getArea() {
        const { data } = await this.$axios.get(MeterAPI.GET_AREA, { companyNo: this.companyCode });
        if (data.code == 0) {
          this.spaceNameList = data.data;
        }
      },
    },
    watch: {
      showMeterData: {
        handler: function (newVal) {
          if (newVal.id != null) {
            this.getDetail();
            this.settingTitle();
          }
        },
        deep: true,
      },
    },
    components: {},
  };
</script>
<style scoped lang="scss">
  .area {
    margin-left: 20px;
    margin-top: 15px;
    background-color: white;
    width: 100%;
    .title {
      font-size: 20px;
      color: black;
      margin-left: 10px;
      margin-bottom: 10px;
      font-weight: bolder;
    }
  }
</style>
